export default {
    async upload(dataURL: string, name: string) {
        return new Promise((resolve, reject) => {

            // Use the fetch API to send the data to the server
            fetch('/api/images/upload', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ image: dataURL, name: name })
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Image uploaded successfully. The image url is:', data.imageUrl)
                    resolve(data.imageUrl)
                })
                .catch(error => {
                    console.error('Error uploading image:', error)
                })
        })
    }

}